var _rect, _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShareModalFb(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    rx: 10,
    fill: "url(#paint0_linear_1098_8577)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.6875 14H18.3119C15.9306 14 14 15.9305 14 18.3119V41.6875C14 44.069 15.9305 45.9993 18.3119 45.9993H29.8404L29.8604 34.5649H26.8894C26.5033 34.5649 26.1899 34.2526 26.1886 33.8665L26.1741 30.1804C26.1726 29.7925 26.4871 29.4768 26.8751 29.4768H29.8409V25.9153C29.8409 21.7823 32.3651 19.5318 36.0519 19.5318H39.0776C39.4644 19.5318 39.7785 19.8456 39.7785 20.2328V23.3406C39.7785 23.7278 39.4647 24.0416 39.078 24.0416L37.2211 24.0427C35.2161 24.0427 34.8276 24.9954 34.8276 26.3939V29.4773H39.2335C39.6536 29.4773 39.9792 29.8439 39.9296 30.2605L39.4927 33.9466C39.4511 34.2995 39.1518 34.5651 38.7966 34.5651H34.8475L34.8275 46H41.6874C44.0687 46 45.9992 44.0693 45.9992 41.688V18.3119C45.9993 15.9306 44.0688 14 41.6875 14Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8402 45.9999L29.8604 34.5654H29.811V45.9999H29.8402Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1098_8577",
    x1: 30,
    y1: 0,
    x2: 30,
    y2: 60,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5B73E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2840B8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareModalFb);
export default __webpack_public_path__ + "static/media/share-modal-fb.e0775fdfa0982241af35f15d26407b9e.svg";
export { ForwardRef as ReactComponent };